<template>
  <span
    class="aha-radio"
    :class="[
      `aha-radio--${size}`,
      {
        'aha-radio--disabled': disabled,
        'aha-radio--checked': checked,
        'custom-mr-2': hasMarginRight,
      },
    ]"
  >
    <span class="aha-radio__core" v-if="checked" />
  </span>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    checked: {
      type: Boolean,
      default: false,
    },
    hasMarginRight: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'md',
    },
  },
}
</script>

<style lang="scss">
.aha-radio {
  display: inline-flex;
  border: 2px solid #D3D7E1;
  background: #FFF;
  border-radius: 50%;
  align-items: center;
  justify-content: center;

  .aha-radio__core {
    background: #4F9BF3;
    border-radius: 50%;
  }
}

.aha-radio--md {
  width: 20px;
  height: 20px;

  .aha-radio__core {
    width: 12px;
    height: 12px;
  }
}

.aha-radio--lg {
  width: 24px;
  height: 24px;

  .aha-radio__core {
    width: 14px;
    height: 14px;
  }
}

.aha-radio--checked {
  border: 2px solid #4F9BF3;
}

.aha-radio--disabled {
  border: 2px solid #D1D1D1;

  .aha-radio__core {
    background: #D1D1D1;
  }
}
</style>
